import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const COLORS = ['#FF6B00', '#437011', '#2563EB', '#8B5CF6', '#EC4899'];

const AgeChart = ({ data }) => {
  if (!data) return null;

  // Transform ageGroups object to array for chart
  const chartData = [
    { name: '18-24 ans', value: data['18-24'] || 0 },
    { name: '25-34 ans', value: data['25-34'] || 0 },
    { name: '35-44 ans', value: data['35-44'] || 0 },
    { name: '45-54 ans', value: data['45-54'] || 0 },
    { name: '55+ ans', value: data['55+'] || 0 },
  ];

  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
      <div className="h-2 bg-gradient-to-r from-orange-500 to-green-600"></div>
      <div className="p-5">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">Distribution par tranche d'âge</h3>
        <p className="text-sm text-gray-500 mb-4">Total: {total} profils avec âge renseigné</p>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="name" stroke="#6b7280" fontSize={12} />
              <YAxis stroke="#6b7280" fontSize={12} />
              <Tooltip 
                contentStyle={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb' }}
                labelStyle={{ color: '#374151' }}
                formatter={(value) => [`${value} personnes`, 'Nombre']}
              />
              <Bar dataKey="value" radius={[4, 4, 0, 0]}>
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default AgeChart;
